import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      {/* <p>&copy; 2025 My React App. All rights reserved.</p> */}
    </footer>
  );
}

export default Footer;